var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { md: "10", "offset-lg": "1" } },
                [
                  _vm.loading
                    ? _c(
                        "v-container",
                        { staticStyle: { height: "400px" } },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "fill-height",
                              attrs: {
                                "align-content": "center",
                                justify: "center"
                              }
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-subtitle-1 text-center",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _vm._v(
                                    "\n                            Loading, please wait...\n                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c("v-progress-linear", {
                                    attrs: {
                                      color: "deep-purple accent-4",
                                      indeterminate: "",
                                      rounded: "",
                                      height: "6"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _c(_vm.mainComponent, { tag: "component" })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("modal-container")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }